// extracted by mini-css-extract-plugin
export default {"blockWrapper":"AdminMailingStatuses_blockWrapper__f1cVd","updateForm":"AdminMailingStatuses_updateForm__oQRlW"};